// Utility functions for video upload
import { toast } from 'react-toastify';

export const showToastMessage = (status, message) => {
  const defaultSuccess = 'Your upload was successful';
  const defaultError = 'Your upload failed';
  if (status === 'success') {
    toast.success(message || defaultSuccess, {
      position: toast.POSITION.BOTTOM_RIGHT,
      enableHtml: false,
    });
  } else {
    toast.error(message || defaultError, {
      position: toast.POSITION.BOTTOM_RIGHT,
      enableHtml: false,
    });
  }
};

export const getVideoDuration = (file, setFileDuration) => {
  const vid = document.createElement('video');
  const fileURL = URL.createObjectURL(file);
  vid.src = fileURL;
  vid.ondurationchange = function () {
    setFileDuration(this.duration);
  };
};

export const capitalizeWords = (name) => {
  return name
    ?.split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const truncateName = (name, limit = 10) => {
  const capitalized = capitalizeWords(name);
  if (capitalized?.length > limit) {
    return `${capitalized.slice(0, limit)}...`;
  }
  return capitalized;
};
